import React from 'react';

export const ErrorMessageRenderer: React.FC = (): React.ReactElement => {
  return <div />;
};
